import React from "react";

import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";

import "../ResultsButtons.css";
import ResultBtn from "../ResultBtn";
import loadTicketsArray from "../../../../shared/functions/loadTicketsArray";

const ResultsErrorsButtons = (props) => {
  const categoryTickets = props.categoryTickets;
  const currentTicketParams = parseInt(props.paramsTicketId);

  let isLastTicket;
  if (props.ticketsArray.length === 1) isLastTicket = true;

  const onResultErrorBtnClick = async (btnType) => {
    switch (btnType) {
      case "next":
        props.setClickedAnswerId(null);
        props.setLoadedBilet(
          props.ticketsArray.find((ticket) =>
            parseInt(ticket.ticketId) === incrementedTicketId)
        );
        break;
      case "mainMenu":
        props.resetToInitialState();
        break;
      case "repeat":
        props.setClickedAnswerId(null);
        break;
      default:
        break;
    }

    let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
    if (errorsArray) {
      errorsArray = errorsArray.filter((el) => el.ticketErrors.length !== 0);
      if (errorsArray.length === 0) localStorage.removeItem("errorsArray");
      else {
        localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
      }
    }
    props.resetNumbersStateArray();

    const loadedTicketsArray = await loadTicketsArray(props.categoryTickets);
    props.setTicketsArray(loadedTicketsArray);

  };

  /*  Подмена ссылки в кнопках следующий билет и повторить билет */
  let incrementedTicketId;
  let firstIdOfNextTicketTask;
  const firstIdOfCurrentTicketTask = props.firstIdOfCurrentTicketTask;
  /* console.log(firstIdOfCurrentTicketTask); */
  const indexOfCurrentTicket = props.ticketsArray.findIndex(
    (el) => parseInt(el.ticketId) === currentTicketParams
  );

  if (indexOfCurrentTicket + 1 !== props.ticketsArray.length) {
    incrementedTicketId = parseInt(
      props.ticketsArray[indexOfCurrentTicket + 1].ticketId
    );
    firstIdOfNextTicketTask =
      props.ticketsArray[indexOfCurrentTicket + 1].tasks[0].taskId;
  } else {
    incrementedTicketId = parseInt(props.ticketsArray[0].ticketId);
    firstIdOfNextTicketTask = props.ticketsArray[0].tasks[0].taskId;
  }
  /* console.log(firstIdOfNextTicketTask, "click"); */
  /* Конец ----- Подмена ссылки в кнопках следующий билет и повторить билет */
  return (
    <div className="result-buttons">
      {props.allErrorsCounter === props.errorsSolved && !isLastTicket ? (
        <ResultBtn
          onClickFunction={() => onResultErrorBtnClick("next")}
          link={`/${categoryTickets}/${incrementedTicketId}/${firstIdOfNextTicketTask}`}
          btnText={"Следующий билет"}
        />
      ) : props.allErrorsCounter !== props.errorsSolved && isLastTicket ? (
        <ResultBtn
          onClickFunction={() => onResultErrorBtnClick("repeat")}
          link={`/${categoryTickets}/${currentTicketParams}/${firstIdOfCurrentTicketTask}`}
          btnText={"Повторить билет"}
        />
      ) : props.allErrorsCounter === props.errorsSolved && isLastTicket ? (
        <ResultBtn
          onClickFunction={() => onResultErrorBtnClick("mainMenu")}
          link={"/"}
          btnText={"Вернуться в главное меню"}
        />
      ) : (
        <div className="result-buttons">
          <ResultBtn
            onClickFunction={() => onResultErrorBtnClick("repeat")}
            link={`/${categoryTickets}/${currentTicketParams}/${firstIdOfCurrentTicketTask}`}
            btnText={"Повторить билет"}
          />
          <ResultBtn
            onClickFunction={() => onResultErrorBtnClick("next")}
            link={`/${categoryTickets}/${incrementedTicketId}/${firstIdOfNextTicketTask}`}
            btnText={"Следующий билет"}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({ type: actionTypes.RESET_NUMBERS_STATE_ARRAY }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    resetToInitialState: () =>
      dispatch({
        type: actionTypes.RESET_TO_INITIAL_STATE,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultsErrorsButtons);
